import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'

interface UseLinkIntegrationCodeProps {
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: AxiosError) => void
}

export type LinkIntegrationCodePayload = {
  id: string
  provider: string
  integration_code_value: string
}

export const useLinkIntegrationCode = ({ onSuccess, onError }: UseLinkIntegrationCodeProps = {}) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['linkIntegrationCode'],
    mutationFn: ({ id, provider, integration_code_value }: LinkIntegrationCodePayload) =>
      privateAxios.post(`/equipment_models/${id}/link_integration_code`, {
        provider,
        integration_code_value,
      }),
    onSuccess,
    onError,
  })
}
